<template>
  <!-- 音频 -->
  <!-- <transition name="audio"> -->
  <ul id="audioBar" class="absolute audio-lists">
    <li v-for="item in data" :key="item.id" :class="audioListClass(item)">
      <Player
        :ref="`${item.type}Ref`"
        :sources="[item.path_url]"
        :value="true"
        :data="item"
        :xhrWithCredentials="true"
      ></Player>
    </li>
    <i
      class="iconfont icon-close cursor-pointer absolute"
      aria-hidden="true"
      @click="hiddenStyle"
    />
  </ul>
</template>

<script>
import Player from '@/components/common/Player'

export default {
  name: 'audio-bar',
  props: {
    showAudio: Boolean,
    data: null
  },
  components: {
    Player
  },
  watch: {
    showAudio(newVal) {
      let bar = document.getElementById('audioBar')
      let obj = this.$refs
      let hiddenAudio = sessionStorage.getItem('hiddenAudio')
      let isActive = bar.classList.contains('active')

      // 如果点语音图标时，不默认自动播放第一条
      // hiddenAudio === 'true'时，是按X关闭控件但 语音还继续播放时，此时控件出现要自动播放
      if ((newVal && !isActive) || hiddenAudio === 'true') {
        bar.classList.add('active')
        let isAutoplay = false
        if (hiddenAudio === 'true') {
          isAutoplay = true
          this.setSeek()
          sessionStorage.removeItem('hiddenAudio')
        }

        let sessionSeek = sessionStorage.getItem('seek')
        sessionSeek = sessionSeek ? JSON.parse(sessionSeek) : sessionSeek

        if (obj) {
          let timer = setTimeout(() => {
            if (sessionSeek) {
              sessionSeek.forEach(item => {
                obj[item.name][0].setSeek(item.value)
                if (isAutoplay) {
                  if (item.playing) {
                    obj[item.name][0].play() // 自动播放有进度的那条
                  }
                }
                // } else {
                //   obj[Object.keys(obj)[0]][0].play() // 自动播放第一条
              })
            }
            clearTimeout(timer)
          }, 100)
        }
      } else {
        this.setSeek()
        bar.classList.remove('active')
      }
    }
  },
  data() {
    return {}
  },
  mounted() {
    sessionStorage.removeItem('seek')
    sessionStorage.removeItem('hiddenAudio')
  },
  methods: {
    setSeek() {
      let obj = this.$refs
      let el
      let emptyArr = []
      for (el in obj) {
        let seek = obj[el][0].seek
        let playing = obj[el][0].playing
        emptyArr.push({ name: el, value: seek, playing })
        // // eslint-disable-next-line no-console
        // console.log(emptyArr)
        if (seek > 0) {
          sessionStorage.setItem('seek', JSON.stringify(emptyArr))
        }
      }
    },
    hiddenStyle() {
      let bar = document.getElementById('audioBar')
      bar.classList.remove('active')
      this.setSeek()
      sessionStorage.setItem('hiddenAudio', 'true')
    },
    audioListClass(item) {
      let className = 'relative '
      if (item.type === 'detail') {
        className += 'detail-css'
      } else if (item.type === 'brief') {
        className += 'brief-css'
      } else {
        className += 'hidden'
      }

      return className
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/styles/css_base.scss';
// 新
.audio-lists {
  top: 8px;
  right: 140px;
  opacity: 0;
  > li {
    height: 34px;
    width: 220px;
    line-height: 32px;
    background-color: $c-tour-2;
    margin-bottom: 3px;
  }
  &.active {
    transition: opacity 0.2s;
    -moz-transition: opacity 0.2s; /* Firefox 4 */
    -webkit-transition: opacity 0.2s; /* Safari 和 Chrome */
    -o-transition: opacity 0.2s; /* Opera */
    opacity: 1;
  }
}

.icon-close {
  width: 1rem;
  height: 1rem;
  line-height: 1rem;
  top: 0rem;
  right: -1rem;
  font-size: 0.6rem;
  text-align: center;
  background-color: $c-tour-2;
  &:before {
    content: 'X';
  }
  &:hover {
    color: #979797;
  }
}
</style>
